function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { ErrorIndicator } from '@arc/frontend/ui-graphics';
import { typography } from '@arc/frontend/ui-theme';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "wco9ji",
  styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%"
} : {
  name: "rjyjvi-ErrorFallback",
  styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;label:ErrorFallback;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "zfxb30",
  styles: "font-style:normal;font-weight:400"
} : {
  name: "yi3i26-ErrorFallback",
  styles: "font-style:normal;font-weight:400;label:ErrorFallback;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
// TODO Make this usable in places things other than the root error boundary (sections, data grids, forms, etc...) so that we can isolate failures.
// TODO Translation support. (We need to be careful not to add something to this that could also cause a crash. Translations are known to cause crashes.)
function ErrorFallback({
  error
}) {
  // When a chunk fails to load, we don't want to show an error screen.
  // The user will see a blank screen and the app will reload.
  if (error instanceof Error && error.name === 'ChunkLoadError') {
    return <div css={_ref} />;
  }
  return <ErrorIndicator message={<div css={_ref2}>
					<p>There was an unexpected problem.</p>
					<div>
						<button type="button" css={typography.clickableLink} onClick={() => {
        window.location.reload();
      }}>
							Try again
						</button>
					</div>
				</div>} />;
}

// This needs to be a function that renders a component instead of just a component because of how Sentry.ErrorBoundary is implemented.
export const errorFallbackRender = errorData => <ErrorFallback {...errorData} />;